import React, { Suspense } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const PhoneCodeListComponent = React.lazy(() => import('./components/PhoneCodeList'));

const PhoneCodeList = () => {
  const { id } = useParams();
  const { name } = useParams();
  const { pathname } = useLocation();

  return (
    <>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <PhoneCodeListComponent 
          userId={id}
          name={name}
        />
      </Suspense>
    </>
  );
}

export default PhoneCodeList;